import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { PermissionListInterface } from '../types/permission-list';
import {
  PermissionListFilter,
  defaultPermissionListFilter,
} from '../types/permission-list-filter';
import {
  AddPermissionInterface,
  UpdatePermissionInterface,
} from '../types/upsert-permission';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private httpClient: HttpClientService) {}

  getPermissionList(
    payload: PermissionListFilter = defaultPermissionListFilter
  ): Observable<ResponseIdentity<DataGrid<PermissionListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.permission.getPermissionList,
      removeEmptyStrings(payload)
    );
  }

  getPermissionDetails(payload: {
    permission_section_id: string;
  }): Observable<ResponseIdentity<PermissionListInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.permission.getPermissionDetails,
      payload
    );
  }

  addPermission(
    payload: AddPermissionInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.permission.addPermission,
      payload
    );
  }

  updatePermission(
    payload: UpdatePermissionInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.permission.updatePermission,
      payload
    );
  }

  deletePermission(payload: {
    permission_section_id: string;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.permission.deletePermission,
      payload
    );
  }
}
